import { useState, useCallback } from 'react';
import { Badge } from 'reactstrap';
import './StatusTooltip.css';
import { Tooltip } from 'reactstrap';

const StatusWithTooltip = (props) => {
    const { id, currentStatus, targetStatus } = props;

    const [statusTooltipOpen, setStatusTooltipOpen] = useState(false);

    const toggle = useCallback(() => {
        setStatusTooltipOpen(!statusTooltipOpen);
    }, [statusTooltipOpen]);

    const getPluginStatusBadge = () => {
        if (currentStatus.state === null || targetStatus === null) {
            return <Badge color="warning">Not Found</Badge>;
        }

        if (
            cacheMatches(targetStatus.isCached, currentStatus.state.cache) &&
            installMatches(
                targetStatus.isInstalled,
                currentStatus.state.installation
            ) &&
            runningMatches(targetStatus.isRunning, currentStatus.state.running)
        ) {
            return <Badge color="success">Normal</Badge>;
        }

        return <Badge color="danger">Abnormal</Badge>;
    };

    const cacheMatches = (expectedStatus, actualStatus) => {
        if (expectedStatus === false && actualStatus == 2) {
            return true;
        }

        if (expectedStatus === true && actualStatus == 3) {
            return true;
        }

        return false;
    };

    const installMatches = (expectedStatus, actualStatus) => {
        if (expectedStatus === false && actualStatus == 2) {
            return true;
        }

        if (expectedStatus === true && actualStatus == 3) {
            return true;
        }

        return false;
    };

    const runningMatches = (expectedStatus, actualStatus) => {
        if (expectedStatus === false && actualStatus == 2) {
            return true;
        }

        if (expectedStatus === true && actualStatus == 3) {
            return true;
        }

        return false;
    };

    // Cached
    const getCachedStatusBadgeColor = () => {
        if (currentStatus.state === null || targetStatus == null) {
            return 'warning';
        }

        return cacheMatches(targetStatus.isCached, currentStatus.state.cache)
            ? 'success'
            : 'danger';
    };

    const getCachedStatusMessage = () => {
        if (currentStatus.state === null) {
            return 'Cached Status Not Found';
        }

        return currentStatus.state.cache === 3 ? 'Cached' : 'Not Cached';
    };

    // Installed
    const getInstalledBadgeColor = () => {
        if (currentStatus.state === null || targetStatus == null) {
            return 'warning';
        }

        return installMatches(
            targetStatus.isInstalled,
            currentStatus.state.installation
        )
            ? 'success'
            : 'danger';
    };

    const getInstalledStatusMessage = () => {
        if (currentStatus.state === null) {
            return 'Installed Status Not Found';
        }

        return currentStatus.state.installation === 3
            ? 'Installed'
            : 'Not Installed';
    };

    // Running
    const getRunningStatusBadgeColor = () => {
        if (currentStatus.state === null || targetStatus == null) {
            return 'warning';
        }

        return runningMatches(
            targetStatus.isRunning,
            currentStatus.state.running
        )
            ? 'success'
            : 'danger';
    };

    const getRunningStatusMessage = () => {
        if (currentStatus.state === null) {
            return 'Running Status Not Found';
        }

        return currentStatus.state.running === 3 ? 'Running' : 'Not Running';
    };

    return (
        <div className="statustooltip">
            <h6 id={`idForTooltip${id}`}>{getPluginStatusBadge()}</h6>
            <Tooltip
                placement="right"
                delay={0}
                target={`idForTooltip${id}`}
                innerClassName="statustooltipcontent"
                arrowClassName="statustooltiparrow"
                isOpen={statusTooltipOpen}
                toggle={toggle}>
                <div className="Row border-bottom mb-2">
                    <div className="Col-12 ">
                        <div className="text-content">
                            <h4>Status: {getPluginStatusBadge()}</h4>
                        </div>
                    </div>
                </div>
                <div className="Row mb-2">
                    <div className="Col-12">
                        <div className="text-center">
                            {/* Downloaded */}
                            <div className="mb-1">
                                <div style={{ height: '20px' }}>
                                    <Badge
                                        className="w-100"
                                        color={`${getCachedStatusBadgeColor()}`}>
                                        {getCachedStatusMessage()}
                                    </Badge>
                                </div>
                            </div>
                            {/* Installed */}
                            <div className="mb-1">
                                <div style={{ height: '20px' }}>
                                    <Badge
                                        className="w-100"
                                        color={`${getInstalledBadgeColor()}`}>
                                        {getInstalledStatusMessage()}
                                    </Badge>
                                </div>
                            </div>
                            {/* Running */}
                            <div className="mb-1">
                                <div style={{ height: '20px' }}>
                                    <Badge
                                        className="w-100"
                                        color={`${getRunningStatusBadgeColor()}`}>
                                        {getRunningStatusMessage()}
                                    </Badge>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {currentStatus.state?.errorMessage && (
                    <div className="Row">
                        <div className="Col-12">
                            <div>
                                <p>{currentStatus.state.errorMessage}</p>
                            </div>
                        </div>
                    </div>
                )}
            </Tooltip>
        </div>
    );
};

export default StatusWithTooltip;
